module.exports = __webpack_public_path__ + "static/bluemuslinmain-c5e60e74f282da87905feee06b9e3a83.png";